import _classCallCheck from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import { __decorate } from "tslib";
// Source: https://github.com/wemake-services/vue-material-input/blob/master/src/components/MaterialInput.vue
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, default_1, [].concat(args));
    _defineProperty(_this, "value", void 0);
    _defineProperty(_this, "type", void 0);
    _defineProperty(_this, "id", void 0);
    _defineProperty(_this, "icon", void 0);
    _defineProperty(_this, "name", void 0);
    _defineProperty(_this, "placeholder", void 0);
    _defineProperty(_this, "readonly", void 0);
    _defineProperty(_this, "disabled", void 0);
    _defineProperty(_this, "required", void 0);
    _defineProperty(_this, "autoComplete", void 0);
    _defineProperty(_this, "min", void 0);
    _defineProperty(_this, "max", void 0);
    _defineProperty(_this, "step", void 0);
    _defineProperty(_this, "minlength", void 0);
    _defineProperty(_this, "maxlength", void 0);
    _defineProperty(_this, "validateEvent", void 0);
    _defineProperty(_this, "valueCopy", _this.value);
    _defineProperty(_this, "focus", false);
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "onValueChange",
    value: function onValueChange(value) {
      this.valueCopy = value;
    }
  }, {
    key: "computedClasses",
    get: function get() {
      return {
        'material--active': this.focus,
        'material--disabled': this.disabled,
        'material--raised': Boolean(this.focus || this.valueCopy)
      };
    }
  }, {
    key: "filledPlaceholder",
    get: function get() {
      if (this.focus) {
        return this.placeholder;
      }
      return '';
    }
  }, {
    key: "handleInput",
    value: function handleInput(event) {
      var value = event.target.value;
      this.$emit('input', value);
      if (this.$parent.$options.name === 'ElFormItem') {
        if (this.validateEvent) {
          this.$parent.$emit('el.form.change', [value]);
        }
      }
    }
  }, {
    key: "handleFocus",
    value: function handleFocus(event) {
      this.focus = true;
      this.$emit('focus', event);
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(event) {
      this.focus = false;
      this.$emit('blur', event);
      if (this.$parent.$options.name === 'ElFormItem') {
        if (this.validateEvent) {
          this.$parent.$emit('el.form.blur', [this.valueCopy]);
        }
      }
    }
  }]);
}(Vue);
__decorate([Prop({
  required: true
})], default_1.prototype, "value", void 0);
__decorate([Prop({
  default: 'text'
})], default_1.prototype, "type", void 0);
__decorate([Prop({
  default: ''
})], default_1.prototype, "id", void 0);
__decorate([Prop({
  default: ''
})], default_1.prototype, "icon", void 0);
__decorate([Prop({
  default: ''
})], default_1.prototype, "name", void 0);
__decorate([Prop({
  default: ''
})], default_1.prototype, "placeholder", void 0);
__decorate([Prop({
  default: false
})], default_1.prototype, "readonly", void 0);
__decorate([Prop({
  default: false
})], default_1.prototype, "disabled", void 0);
__decorate([Prop({
  default: true
})], default_1.prototype, "required", void 0);
__decorate([Prop({
  default: 'off'
})], default_1.prototype, "autoComplete", void 0);
__decorate([Prop({
  default: 0
})], default_1.prototype, "min", void 0);
__decorate([Prop({
  default: 10000
})], default_1.prototype, "max", void 0);
__decorate([Prop({
  default: 1
})], default_1.prototype, "step", void 0);
__decorate([Prop({
  default: 0
})], default_1.prototype, "minlength", void 0);
__decorate([Prop({
  default: 20
})], default_1.prototype, "maxlength", void 0);
__decorate([Prop({
  default: true
})], default_1.prototype, "validateEvent", void 0);
__decorate([Watch('value')], default_1.prototype, "onValueChange", null);
default_1 = __decorate([Component({
  name: 'MaterialInput'
})], default_1);
export default default_1;